export const TEST_OTP = '123456';

export const TEST_LOGIN = {
  email: 'test@xgain.ai',
  country_code: '+1',
  phone: '5550100778',
};

export const TEST_SIGNUP = {
  first_name: 'Demo',
  last_name: 'User',
  email: 'demo@xgain.ai',
  country_code: '+1',
  phone: '5550101234',
};

export const isDevTestCredentialsEnabled = process.env.NODE_ENV === 'development';

export const isTestSignupEmail = (email) =>
  isDevTestCredentialsEnabled
  && String(email || '').trim().toLowerCase() === TEST_SIGNUP.email;

export const isTestLoginEmail = (email) =>
  isDevTestCredentialsEnabled
  && String(email || '').trim().toLowerCase() === TEST_LOGIN.email;

export const isTestLoginPhone = (countryCode, phone) =>
  isDevTestCredentialsEnabled
  && String(countryCode || '').trim() === TEST_LOGIN.country_code
  && String(phone || '').replace(/\D/g, '') === TEST_LOGIN.phone;
